import {AnyAction} from 'redux'
import {
  DELETE_RSVP_OLD,
  GET_MEMBER_RSVP_OLD,
  SEND_RSVP_OLD,
  SKIP_GET_MEMBER_EVENT_RSVP,
  UPDATE_RSVP_STATUS_OLD,
  deleteRsvp,
  getMemberRsvp,
  sendRsvp,
  updateRsvpStatus,
} from '../actions/rsvp'
import {MemberRsvp} from '../types/state'

const getDefaultState = (): MemberRsvp => ({
  rsvp: null,
  loaded: false,
})

export const memberRsvp = (state = getDefaultState(), action: AnyAction) => {
  switch (action.type) {
    case GET_MEMBER_RSVP_OLD.SUCCESS:
      return {...state, rsvp: action.payload, loaded: true}
    case getMemberRsvp.fulfilled.toString():
      if (action.payload) {
        return {...state, rsvp: action.payload, loaded: true}
      }

      return {...state, loaded: true}
    case SEND_RSVP_OLD.SUCCESS:
    case sendRsvp.fulfilled.toString():
      return {...state, rsvp: action.payload.rsvp, loaded: true}
    case DELETE_RSVP_OLD.REQUEST:
    case deleteRsvp.pending.toString():
      return {...state, rsvp: null, loaded: true}
    case UPDATE_RSVP_STATUS_OLD.SUCCESS: {
      const [, , status] = action.args
      return {...state, rsvp: {...state.rsvp, status}}
    }
    case updateRsvpStatus.fulfilled.toString(): {
      const {status} = action.meta.arg
      return {...state, rsvp: {...state.rsvp, status}}
    }
    case GET_MEMBER_RSVP_OLD.REQUEST:
    case getMemberRsvp.pending.toString():
      return {...state, loaded: false}
    case GET_MEMBER_RSVP_OLD.FAILURE:
    case getMemberRsvp.rejected.toString():
      return {...state, loaded: true}
    case SKIP_GET_MEMBER_EVENT_RSVP:
      return {...state, loaded: true}
    default:
      return state
  }
}
